import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { EnvSetting } from '../utils/env-setting';

@Injectable({
  providedIn: 'root'
})

export class EncryptionService {
  constructor() { }
  encryptText(plainText: string) {
    const ky = EnvSetting.colorCode.trim();
    let result: string = plainText;
    if (ky) {
      const key = CryptoJS.enc.Utf8.parse(ky);
      const iv = CryptoJS.enc.Utf8.parse(ky.substring(0, 16).trim());

      result = CryptoJS.AES.encrypt(plainText.trim(), key, {
        iv,
        mode: CryptoJS.mode.CBC
      }).toString();
    }
    return result;
  }

  encryptURLParameters(plainText: string) {
    return encodeURIComponent(this.encryptText(plainText)).replace(/[%]/g, '!');
  }
}
